// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse
} from '@angular/common/http';

// --- RxJs
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- Hs Code
import { AppService } from '../app.service';
import { ActivationBaseService } from './activation-base.service';
import { environment } from '../../../../environments/environment';
import {
  ResolvedTokenModel,
  ApplicationError,
  SimpleStringWrapper
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ActivationService extends ActivationBaseService {
  constructor(
    private appService: AppService,
    private httpClient: HttpClient,
    private translate: TranslateService
  ) {
    super();
  }

  resolveToken(token: string): void {
    const uri =
      environment.apiConfig.baseUrl +
      environment.apiConfig.resolveTokenApi +
      `?tokenValue=${encodeURIComponent(token)}`;

    this.appService.setLoading(true);
    this._token$.next(null);
    this._emailAddress$.next(null);
    this._otac$.next(null);

    this.httpClient
      .get<ResolvedTokenModel>(uri)
      .pipe(catchError(this.handleResolveError.bind(this)))
      .subscribe(result => {
        this.appService.setLoading(false);
        this._token$.next(token);
        this._emailAddress$.next(result.emailAddress);
      });
  }

  activateAccount(token: string): Observable<SimpleStringWrapper> {
    const uri =
      environment.apiConfig.baseUrl + environment.apiConfig.activateApi;

    return this.httpClient
      .post<SimpleStringWrapper>(uri, { value: token })
      .pipe(catchError(this.handleActivateError.bind(this)));
  }

  private handleResolveError(err) {
    const error = this.handleError(err);

    return of({
      emailAddress: null,
      error: error.errorMessage,
      tokenValue: null
    } as ResolvedTokenModel);
  }

  private handleActivateError(err) {
    const error = this.handleError(err);

    return of(null as SimpleStringWrapper);
  }

  private handleError(err): ApplicationError {
    this.appService.setLoading(false);

    console.error(err);

    let error: ApplicationError;
    let errormessage = '';

    if (err && err instanceof HttpErrorResponse) {
      // A client-side or network error occurred. Handle it accordingly.
      let detailedMessage = `${err.message}`;
      if (err.statusText) {
        detailedMessage += `<br/>${err.statusText}`;
      }

      if (err.error.text){
        errormessage = err.error.text;
      }
      else{
        errormessage = this.translate.instant('errorMessageActivation');
      }

      error = {
        errorMessage: errormessage,
        errorNumber: err.status,
        detailedMessage
      } as ApplicationError;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (err.error.text){
        errormessage = err.error.text;
      }
      else{
        errormessage = this.translate.instant('errorMessageActivation');
      }

      error = {
        errorMessage: errormessage,
        errorNumber: err.status
      } as ApplicationError;
    }
    this.appService.setLastError(error);
    return error;
  }
}
